import { type FC, useContext } from "react";
import { type DragDropWrapperProps } from "../../../Common/Forms/DragDrop/DragDropTypes";
import { ReceiptTypeContext } from "../../../Common/Receipts/Receipt";
import { type ReceiptServerTypeUnion } from "../../../Data/_Bases/BaseReceiptRepository";

const TYPE_CLASSES = {
    TEXT_ONLY: "max-w-[80mm] min-h-[297mm] p-[4mm] font-mono",
    NORMAL   : "max-w-[80mm] min-h-[297mm] p-[4mm]",
    A4       : "max-w-[210mm] min-h-[297mm] p-[10mm]",
    EMAIL    : "max-w-[210mm] min-h-[297mm] p-[10mm]",
} satisfies Record<ReceiptServerTypeUnion, string>;

export const ReceiptModifyWrapper: FC<DragDropWrapperProps> = ({ children }) => {
    const type = useContext(ReceiptTypeContext);

    return (
        <div className={`w-screen ${TYPE_CLASSES[type]}`}>
            {children}
        </div>
    );
};
